import React, { Component } from "react";
import { Cascader } from "antd";
import * as area from "../../service/area";

import "./index.less";

export default class AreaSelect extends Component {

  state = {
    loading: true,
    options: [],
  };

  value = [];

  componentDidMount() {
    this.initComponent();
  };

  initComponent = () => {
    const param = {
      code: this.props.restrict,
    };
    area.getAreaTree(param).then(options => {
      this.setState({
        ...this.state,
        loading: false,
        options,
      });
    });
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.value !== nextProps.value) {
      this.recomputeValue(nextProps);
    }
    return true;
  }

  recomputeValue = (nextProps) => {
    let value = (nextProps.value || "") + "";
    if (!value || nextProps.multiple) {
      // 空值、多选不处理
      return [];
    }
    // 判断限制区域码级别
    let index = 0;
    const items = area.getConfig();
    if (this.props.restrict) {
      const restrict = this.props.restrict + "";
      for (let i = 0; i < items.length; ++i) {
        const item = items[i];
        if (Number(restrict.substring(item.complete - item.simple, item.complete)) > 0) {
          index = i;
        } else {
          break;
        }
      }
    }
    const values = [];
    for (let i = index; i < items.length; ++i) {
      const item = items[i];
      if (Number(value.substring(item.complete - item.simple, item.complete)) > 0) {
        values.push(area.getFullAreaCode(value.substring(0, item.complete)));
      } else {
        break;
      }
    }
    this.value = values;
  };

  onChange = (values, selectedOptions) => {
    if (!this.props.multiple) {
      values = values ? values[values.length - 1] : values;
    }
    this.props.onChange && this.props.onChange(values, selectedOptions);
  };

  render() {
    const { options, } = this.state;
    return (
      <Cascader
        options={options}
        expandTrigger="hover"
        {...this.props}
        changeOnSelect
        value={this.value}
        onChange={this.onChange}
        fieldNames={{ label: "name", value: "fullCode", children: "children" }}
      />
    );
  };
};
